// NextLocationContext.js
import React, { createContext, useContext, useState } from 'react';

// Create Context
const NavigationLocationContext = createContext();

// Provider component to wrap your app and provide the context
export const NavigationLocationProvider = ({ children }) => {
  const [nextLocation, setNextLocation] = useState(null);

  return (
    <NavigationLocationContext.Provider value={{ nextLocation, setNextLocation }}>
      {children}
    </NavigationLocationContext.Provider>
  );
};

// Custom hook to use the context in components
export const useNavigationLocation = () => {
  return useContext(NavigationLocationContext);
};
